<div class="row mb-2" *ngIf="!minimize">
  <h3 class="col-12 page-title text-center" translate>EDI</h3>
  <div class="col-12 col-sm-4 mb-2">
    <a class="card border h-100" routerLink="orders">
      <div class="card-body" [ngClass]="{ 'p-0': minimize }" title="Lists all EDI messages for overview and management">
        <h5 class="card-title text-center" [ngClass]="{ 'my-2': minimize }">Manage orders</h5>
        <p class="card-text" *ngIf="!minimize">
          Here you can manage you orders and send them to ERP or change potential order failures
        </p>
      </div>
    </a>
  </div>
</div>
<router-outlet></router-outlet>
